import saveChangesTemplate from "../view/header/saveChanges/saveChangesTemplate";
import PreventNavigationUrls from "./PreventNavigationUrls";
import saveChangesController from "../view/header/saveChanges/saveChangesController";
import { setAriaLabelledByToElement } from "../../../../../react/core/utils/accessibilityHelpers";
import ModalAccessibility from "../../../ModalAccessibility";

var PreventNavigationService = function ($state, $rootScope, $window, $location, $modal) {
    var service = this;

    service.isEnroll = false;
    /**
     * The attributes below represent the original validations intended for participant enroll prevent navigation
     */
    function originalEnrollValidations(menu) {
        const statePreventEnroll =
            $state.current.name.indexOf("enrollment") !== -1 &&
            $state.current.name.indexOf("Error") === -1 &&
            $state.current.url.indexOf("confirm-changes") === -1 &&
            $state.current.name.indexOf("enrollment.confirmation") === -1;
        const isEnrollmentPage = $window.location.href.indexOf("/participant/enroll/") !== -1;
        const preventEnroll = isEnrollmentPage && statePreventEnroll;
        const preventEnrollWithLogout = preventEnroll && !$rootScope.isIncompleteModalExist;

        if (preventEnrollWithLogout) {
            service.isEnroll = true;
            return true;
        }

        return false;
    }

    service.isPreventUrl = function () {
        if (originalEnrollValidations()) {
            return true;
        }
        const hasPreventURl = PreventNavigationUrls.urlArray.some((url) => {
            return $window.location.href.indexOf(url) !== -1;
        });

        return hasPreventURl && !$rootScope.isIncompleteModalExist;
    };

    function setupModalScope(e, menuType) {
        service.nextVal =
            e !== null &&
            e !== undefined &&
            e.currentTarget != undefined &&
            e.currentTarget.href != undefined
                ? e.currentTarget.href
                : "";
        if (
            service.nextVal === "" ||
            service.nextVal === undefined ||
            service.nextVal.indexOf("unsafe:javascript") !== -1 ||
            menuType === "PROFILE_MOBILE" ||
            menuType === "LOGOUT"
        ) {
            if (menuType === "LIAT_LOGO" || menuType === "LIAT_HOME") {
                var url = $location.url();

                var transition = true;
                var statesToCheck = [
                    // we don't want to re-route and refresh the page if we are already at LIAT
                    "/retirement-income",
                    "/health-care-costs",
                    "/how-do-i-compare",
                    "/plan-balances"
                ];

                var re;
                var leading = /^.*/;
                var noTrailingSlash = /[^/]*$/;

                for (var i = 0; i < statesToCheck.length; i++) {
                    re = new RegExp(leading.source + statesToCheck[i] + noTrailingSlash.source);
                    if (re.test(url)) {
                        transition = false;
                        break;
                    }
                }

                if (transition) {
                    service.nextVal =
                        $location.protocol() +
                        "://" +
                        $location.host() +
                        $rootScope.retirementIncomeUrl;
                }
            } else if (menuType === "INVESTING") {
                service.nextVal =
                    $rootScope.participantAppURL + "/#/guidance/allocations/selection";
            } else if (menuType === "PROFILE_MOBILE") {
                service.nextVal =
                    $rootScope.loginAppURL +
                    "/#/profile" +
                    "?accu=" +
                    AccuCodeService.getAccuCode();
            } else if (menuType === "LOGOUT") {
                service.nextVal = menuType;
            } else if (menuType === "BREADCRUMB") {
                var href = e.originalEvent.explicitOriginalTarget
                    ? e.originalEvent.explicitOriginalTarget.href
                    : e.originalEvent.target.href;
                service.nextVal = href;
            } else if (menuType === "CHANGEACCOUNT" || menuType === "NOTIFICATION") {
                service.nextVal = menuType;
            }
        }
    }

    function addAriaLabelledByToModal() {
        setAriaLabelledByToElement("auto-increase-wrapper", "modal-title");
    }

    service.preventNavigation = function (e, menuType, scope) {
        if (e !== null && e !== undefined) {
            e.preventDefault();
        }
        setupModalScope(e, menuType);
        scope.nextVal = service.nextVal;
        scope.isEnroll = service.isEnroll;
        const modalInstace = $modal.open({
            template: saveChangesTemplate,
            controller: saveChangesController,
            controllerAs: "enrollCtrl",
            size: "md",
            windowClass: "auto-increase-wrapper bigger-z-index",
            scope: scope,
            rootScope: $rootScope,
            window: $window
        });
        modalInstace.rendered.then(addAriaLabelledByToModal);
        ModalAccessibility.onOpenModal(".modal-dialog");
    };
};

PreventNavigationService.$inject = ["$state", "$rootScope", "$window", "$location", "$modal"];

export default PreventNavigationService;
